import { Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';

interface IText {
  title: string;
  body: {
    lineOne: string;
    lineTwo: string;
  };
}

export const TextBody = () => {
  const dictionary = useDictionary(
    Dictionary,
    DICTIONARY.CompassRights
  ).agreementModal;

  const isDesktop = useIsDesktop();

  const text: IText[] = [
    { title: dictionary.paragraph1.title, body: dictionary.paragraph1.body },
    { title: dictionary.paragraph2.title, body: dictionary.paragraph2.body },
    {
      title: isDesktop
        ? dictionary.paragraph3.title
        : dictionary.paragraph3.titleMobile,
      body: dictionary.paragraph3.body,
    },
  ];

  return (
    <Stack gap={isDesktop ? '12px' : '24px'} alignItems={'center'}>
      <Typography variant={'h2'}>{dictionary.title}</Typography>
      <Stack gap={'24px'}>
        {text.map((textItem: IText, index: number) => (
          <Stack key={index}>
            <Typography
              variant={'body1'}
              width='fit-content'
              margin={isDesktop ? '0 0 8px 0' : '0 auto 8px auto'}
            >
              {textItem.title}
            </Typography>
            <Typography variant={'body6'}>{textItem.body.lineOne}</Typography>
            <Typography
              variant={'body6'}
              maxWidth={index > 0 ? '615px' : '640px'}
            >
              {textItem.body.lineTwo}
            </Typography>
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
